import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { LineItemExpanded as LineItemExpandedUnified } from './LineItemExpanded'
import { LineItemExpandedLegacy } from './LineItemExpandedLegacy'
import type { LineItemExpandedProps } from './useLineItemExpandedModel'

export type { LineItemExpandedProps } from './useLineItemExpandedModel'

export const LineItemExpanded: React.FC<LineItemExpandedProps> = props =>
  getFeatureFromCache(FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS) ? (
    <LineItemExpandedUnified {...props} />
  ) : (
    <LineItemExpandedLegacy {...props} />
  )
